import React, { Component, createRef } from 'react';
import './App.css';
import './Log.css';
import LogLang from './LogLang.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class LogMain extends React.Component {

	constructor(props) {

		super(props);
		
		this.logRef = createRef();

		this.state = {
			userSettingsJsonObj: null,
			userStorageID: "",
			year: 0,
			month: 0,
			day: 0,
			logText: "",
		}
	}

	async componentDidMount() {

		var userID = this.props.userID;
		var fullName = this.props.fullName;
		this.serverGetUserSettingsData(userID, fullName);
	}
	
	scrollToBottom() {
		this.logRef.current?.scrollIntoView({ behavior: 'smooth' });
	};	

	async serverGetUserSettingsData(userID, userFullName) {

		if (userID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getusersettingsdata?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var userSettingsJsonObj = null;
		
		try {
			var res = await fetch(url);
			userSettingsJsonObj = await res.json();
		} catch (err) {
		}

		if (userSettingsJsonObj === null) {
			return;
		}		
		
		var userStorageID = userSettingsJsonObj.userStorageID;

		var currentDateTime = new Date();
		var year = currentDateTime.getFullYear();
		var month = currentDateTime.getMonth() + 1;
		var day = currentDateTime.getDate();

		this.getLogTextFromServer(userStorageID, year, month, day);

		this.setState({
			year: year,
			month: month,
			day: day,
			userSettingsJsonObj: userSettingsJsonObj,
			userStorageID: userStorageID,
		});

		setTimeout(() => {
			this.scrollToBottom();
		}, 300);
		setTimeout(() => {
			this.scrollToBottom();
		}, 1000);
	}

	async getLogTextFromServer(userStorageID, year, month, day) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var filename = year + "-" + this.props.getTwoDigits(month) + "-" + this.props.getTwoDigits(day) + ".txt";
		var url = baseURLAPI + "/user/" + userStorageID + "/log/" + filename;

		var logText = await this.props.serverDownloadTextFile(url);

		this.setState({
			logText: logText,
		});
	}

	prevDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec - 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.getLogTextFromServer(this.state.userStorageID, year2, month2, day2);
	}
	
	nextDate() {

		var year = this.state.year;
		var month = this.state.month;
		var day = this.state.day;
		
		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);
		
		var unixTimeSec = Math.floor(dateObj.getTime() / 1000);
		var unixTimeSec2 = unixTimeSec + 24*3600;
		
		var dateObj2 = new Date(unixTimeSec2 * 1000);

		var year2 = dateObj2.getFullYear();
		var month2 = dateObj2.getMonth() + 1;
		var day2 = dateObj2.getDate();

		this.setState({
			year: year2,
			month: month2,
			day: day2,
		});

		this.getLogTextFromServer(this.state.userStorageID, year2, month2, day2);
	}

	datePickerSetDate(dateObj) {

		var year = dateObj.getFullYear();
		var month = dateObj.getMonth() + 1;
		var day = dateObj.getDate();

		var filename = year + "-" + this.props.getTwoDigits(month) + "-" + this.props.getTwoDigits(day) + ".txt";

		this.setState({
			year: year,
			month: month,
			day: day,
			filename: filename,
		});

		this.getLogTextFromServer(this.state.userStorageID, year, month, day);
	}
	
	getDateStringFromYMD(year, month, day) {
		var dateString;
		dateString = this.props.getTwoDigits(day) + "." + this.props.getTwoDigits(month) + "." + year + ".";
		return dateString;
	}
	
	getDateObjFromYMD(year, month, day) {

		var dateObj = new Date();
		dateObj.setFullYear(year, month-1, day);
		dateObj.setHours(0);
		dateObj.setMinutes(0);
		dateObj.setSeconds(0);
		dateObj.setMilliseconds(0);

		return dateObj;
	}
	
	renderDateInput(index) {
		
		var logText = this.state.logText;
		if (index === 2) {
			if (logText === "") {
				return;
			}
		}
		
		var dateObj = this.getDateObjFromYMD(this.state.year, this.state.month, this.state.day);

		if (index === 2) {
			return (
				<center ref={this.logRef}>
					<div className="LogMainDateContainer">
						<div className="LogMainDatePrev" onClick={() => this.prevDate()}>&lt;&lt;</div>
						<DatePicker 
							className="LogMainDateString" 
							selected={dateObj} onChange={(date) => this.datePickerSetDate(date)} 
							dateFormat="dd.MM.yyyy."
						/>
						<div className="LogMainDateNext" onClick={() => this.nextDate()}>&gt;&gt;</div>
					</div>
				</center>
			);
		}

		return (
			<center>
				<div className="LogMainDateContainer">
					<div className="LogMainDatePrev" onClick={() => this.prevDate()}>&lt;&lt;</div>
					<DatePicker 
						className="LogMainDateString" 
						selected={dateObj} onChange={(date) => this.datePickerSetDate(date)} 
						dateFormat="dd.MM.yyyy."
					/>
					<div className="LogMainDateNext" onClick={() => this.nextDate()}>&gt;&gt;</div>
				</div>
			</center>
		);
	}

	renderLogText() {
		
		var logText = this.state.logText;
		var logText2 = this.props.convertTextNewlineToBr(logText);

		return (
			<div className="LogText">	
				{logText2}
			</div>
		);
	}
	
	render() {
		
		return (
			<div className="LogMainTopContainer">
				<div style={{height: "20px"}}></div>
				<div className="LogMainTopTitle">{this.props.getLang(LogLang, "logMainTopTitle")}</div>
				<div style={{height: "20px"}}></div>
				{this.renderDateInput(1)}
				<div style={{height: "20px"}}></div>
				{this.renderLogText()}
				<div style={{height: "20px"}}></div>					
				{this.renderDateInput(2)}
				<div style={{height: "20px"}}></div>					
			</div>
		);
	}
}

export default LogMain;

